// One definition of "sold out" for the catalogue.
//
// The API sends `available` straight from the stock tallies as 1 / 0 / null
// (null = nothing tallied yet) and as `false` when a rule settled it (a
// stock-limit group, or "no per-man cap and no tally" for limited clients).
// Product.vue treated both falsy values as sold out; ModalProduct.vue only
// knew about 0 for sizes and never looked at a plain product's flag at all,
// so a card drawn as "אזל מהמלאי" opened into a modal that added the item.
export function isSoldOut(item) {
  if (!item) {
    return false;
  }
  return item.available === 0 || item.available === false;
}

// A variant's flag lives in two places: `selected_subitems` (the rows the
// order line is written from, carrying every listing rule) and the bare
// `sub_items` relation (tallies only). Sold out when either says so.
export function variantIsSoldOut(product, attribute) {
  const selected = Object.values(product?.selected_subitems || {}).find(
    (item) => item.attribute === attribute
  );
  const bare = (product?.product?.sub_items || []).find(
    (item) => item.attribute === attribute
  );
  return isSoldOut(selected) || isSoldOut(bare);
}
